import type { IconData } from '@stacksjs/iconify-core'

export const smiley: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3.92-4.606a1 1 0 1 1 1.84-.788a2.264 2.264 0 0 0 4.16 0a1 1 0 1 1 1.84.788a4.264 4.264 0 0 1-7.84 0M7 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default smiley
